import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol viewBox=\"0 0 21 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-left\">\n<path d=\"M13.3223 3.838L6.85727 10.498C6.74018 10.6151 6.68164 10.7551 6.68164 10.918C6.68164 11.0809 6.74018 11.2274 6.85727 11.3574L13.3223 18.0174C13.4393 18.1215 13.576 18.1736 13.7323 18.1736C13.8885 18.1736 14.0252 18.1151 14.1423 17.998C14.2593 17.8809 14.3179 17.7442 14.3179 17.588C14.3179 17.4317 14.2593 17.2951 14.1423 17.178L8.04852 10.928L14.1423 4.678C14.2593 4.56091 14.3179 4.42425 14.3179 4.268C14.3179 4.11175 14.2593 3.97508 14.1423 3.858C14.0252 3.74091 13.8885 3.68237 13.7323 3.68237C13.576 3.68237 13.4393 3.73446 13.3223 3.83862V3.838Z\" fill=\"#314455\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/arrow-left.svg
// module id = Ofr2
// module chunks = 262